import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import { createRoot } from "react-dom/client";
import axios from "axios";

import "./assets/scss/_app.scss";

import { initializeSentry } from "./config/sentry";

import App from "./App";

const container = document.getElementById("root");
const root = createRoot(container);

// Initialize Sentry with the API client for interceptor configuration
initializeSentry(axios);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
